import { createSlice } from '@reduxjs/toolkit';
import { asyncIsFulfilled, asyncIsPending, asyncIsRejected } from '../asyncConfig';
import { getUsers, getUsersFulfilled, getUserById, updateAccountStatusById, updateUserDetailsById, updateUserVerificationStatus, creditRefund } from './users_thunk';

const initialState = {
  users: [],
  status: '',
  message: ''
}

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  extraReducers: {
    [getUsers.pending]: asyncIsPending,
    [getUsers.rejected]: asyncIsRejected,
    [getUsers.fulfilled]: getUsersFulfilled,
    [getUserById.pending]: asyncIsPending,
    [getUserById.rejected]: asyncIsRejected,
    [getUserById.fulfilled]: getUsersFulfilled,
    [updateUserVerificationStatus.pending]: asyncIsPending,
    [updateUserVerificationStatus.rejected]: asyncIsRejected,
    [updateUserVerificationStatus.fulfilled]: asyncIsFulfilled,
    [updateUserDetailsById.pending]: asyncIsPending,
    [updateUserDetailsById.rejected]: asyncIsRejected,
    [updateUserDetailsById.fulfilled]: asyncIsFulfilled,
    [updateAccountStatusById.pending]: asyncIsPending,
    [updateAccountStatusById.rejected]: asyncIsRejected,
    [updateAccountStatusById.fulfilled]: asyncIsFulfilled,
    [creditRefund.pending]: asyncIsPending,
    [creditRefund.rejected]: asyncIsRejected,
    [creditRefund.fulfilled]: asyncIsFulfilled,
  }
});

export default usersSlice.reducer;